export const VIDEO_CALL_IDENTITY_WILL_CHANGE_EVENT =
  "teachplus:video-call-identity-will-change";

export const dispatchVideoCallIdentityWillChange = () => {
  if (!import.meta.client) {
    return;
  }

  window.dispatchEvent(new Event(VIDEO_CALL_IDENTITY_WILL_CHANGE_EVENT));
};
